import React from 'react';
import { Helmet } from 'react-helmet';

const Metadata = () => (
  <Helmet>
    <meta charSet="utf-8" />
    <title>Jessica Wu</title>
    <link rel="canonical" href="https://jvssicawu.github.io/" />
  </Helmet>
);

export default Metadata;
